module.exports = __webpack_public_path__ + "img/sad_panda2.4ce3297e.gif";